import * as Sentry from "@sentry/react"

export default function initSentry() {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      integrations: [],
    })
}

